module.exports = __webpack_public_path__ + "img/14.5d94e876.png";